import { BaseRequest } from './BaseRequest';

export class AiAgentsPlanRequest extends BaseRequest {
    OrganizationId: string;
}